import { Category } from '../interfaces/Category/Category';
import { CategoryTreeNode } from '../interfaces/Category/CategoryTreeNode';

export const buildCategoryTree = (
  categories: Category[],
): CategoryTreeNode[] => {
  const tree: CategoryTreeNode[] = categories.map((category) => ({
    ...category,
    children: [],
  }));

  tree.forEach((category, i) => {
    if (!Number.isFinite(category.parentID)) {
      return;
    }

    const parentIndex = tree.findIndex((x) => x.id === category.parentID);
    if (parentIndex > -1) {
      tree[parentIndex].children.push(tree[i]);
    }
  });

  return tree.filter((category) => !Number.isFinite(category.parentID));
};
